import { getDeviceSchema, QUEUE } from "callable-data-objects";
import { CallableInput, CallableToggle } from "Components/Shared";
import QueueItemTypeSelect from "Components/Shared/QueueItemTypeSelect";
import QueueItemValue from "Components/Shared/QueueItemValue";
import TTSSelect from "Components/Shared/TTSSelect";
import { Field, FieldArray, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import { get, isEmpty } from "lodash";
import React, { Fragment } from "react";
import { Button, Card, Form, Header } from "semantic-ui-react";

const QueueForm = () => {
  const { update, device } = useDevice();

  if (!device) return <Fragment />;

  return (
    <Formik
      initialValues={device}
      enableReinitialize={true}
      validationSchema={getDeviceSchema(QUEUE)}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {({ values, errors, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Field
            name='queue.queueName'
            label='Name of queue'
            component={CallableInput}
          />

          <Field
            name='queue.loop'
            label='Loop'
            type='number'
            component={CallableInput}
          />

          <Field
            toggle
            name={`queue.ringEndpoints`}
            label='Ring Endpoints'
            component={CallableToggle}
          />

          <TTSSelect name='queue.ttsLanguage' label='TTS Language' />

          <FieldArray
            name='queue.items'
            render={(arrayHelpers) => {
              return (
                <Card fluid>
                  <Card.Content>
                    <Header as='h5'>Announcement Builder</Header>
                  </Card.Content>
                  <Card.Content>
                    <Button
                      primary
                      icon='plus'
                      onClick={() =>
                        arrayHelpers.push({ type: "say", text: "" })
                      }
                    >
                      Create Item
                    </Button>
                  </Card.Content>
                  {get(values, "queue.items", []).map(
                    (item: any, index: number) => (
                      <Card.Content>
                        <Form.Group key={index} widths='equal'>
                          <QueueItemTypeSelect
                            label='Type'
                            name={`queue.items.${index}.type`}
                          />
                          <QueueItemValue
                            type={item.type}
                            label='Value'
                            name={`queue.items.${index}.text`}
                          />
                          <Button
                            size='mini'
                            color='red'
                            icon='delete'
                            onClick={() => arrayHelpers.remove(index)}
                          />
                        </Form.Group>
                      </Card.Content>
                    )
                  )}
                </Card>
              );
            }}
          />

          <Button primary type='submit' disabled={!isEmpty(errors)}>
            Update
          </Button>

          {errors && JSON.stringify(errors)}
        </Form>
      )}
    </Formik>
  );
};

export default QueueForm;
